var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"clearfix",attrs:{"id":"footer"}},[_c('div',{staticClass:"footer-wrapper"},[_c('h1',[_vm._v("@2024 by Man Ho Lam")]),_c('h1',[_vm._v("Supported by Vue2")])])])
}]

export { render, staticRenderFns }